import React from 'react';
import { contentContainer as contentConainerStyle } from "../styles/SweetAlertStyles";
var Content = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "text-muted lead", style: contentConainerStyle }, children));
};
export default Content;
//# sourceMappingURL=Content.js.map